import { render, staticRenderFns } from "./dataform.vue?vue&type=template&id=187a61f7&scoped=true&"
import script from "./dataform.vue?vue&type=script&lang=js&"
export * from "./dataform.vue?vue&type=script&lang=js&"
import style0 from "./dataform.vue?vue&type=style&index=0&id=187a61f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a61f7",
  null
  
)

export default component.exports